import { useEffect, useState } from 'react';

function DateFilterSelector({ onFilterChange, from, to }) {
  const [fromDate, setFromDate] = useState(from);
  const [toDate, setToDate] = useState(to);

  useEffect(() => {
    setFromDate(from);
    setToDate(to);
  }, [from, to]);

  return (
    <div className="date-filter">
      <div className="h4Title">Seleccione el rango de fechas que desea consultar</div>
      <div className="date-filter__row">
        <label>Desde</label>
        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <label>Hasta</label>
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
        <button type="button" onClick={() => onFilterChange({ fromDate, toDate })}>
          Consultar
        </button>
      </div>
    </div>
  );
}

export default DateFilterSelector;
